// extracted by mini-css-extract-plugin
module.exports = {"formBox":"styles_formBox__CtLoT","setPasswordWrapper":"styles_setPasswordWrapper__u4_3d"};